import { httpClient } from 'src/config/http';
import { store } from 'src/config/rootStore';
import { isAuthenticated } from 'src/modules/auth/selectors/authenticationSelectors';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';
import { ContentLanguage } from '../models/language';

export class ContentLanguagesService {
    constructor(private toastNotificationsService: ToastNotificationsService) {}

    public async fetchContentLanguages(): Promise<ContentLanguage[] | void> {
        try {
            const { getState } = store;
            const authenticated = isAuthenticated(getState());
            if (authenticated) {
                return await httpClient.GET<ContentLanguage[]>(`content-languages/`);
            }

            return await httpClient.GET_UNAUTHENTICATED<ContentLanguage[]>(`content-languages/`);
        } catch {
            this.toastNotificationsService.renderErrorToast(
                "Couldn't fetch a list of content languages",
            );
        }
    }
}
